import { useRouter } from "next/router";
import { trackGA4Event } from "@/lib/tracking/gaHelpers";
import { events } from "@/lib/tracking/constants";
import { usePath } from "@/contexts/path/path";
import css from "./.module.scss";
import { AppLink } from "@/components/new-resolver/app.ink";
import { useAuthState } from "@/contexts/auth/auth.provider";
import { Icon } from "@/components/icon";
import { useEffect, useState } from "react";
import { DEFAULT_CATEGORY } from "@/lib/path-resolver-middlewares/category";
import {
  trackDailyRentStart,
  trackGenericCTAClickEvent,
} from "@/lib/tracking/trackNavigationEvents";

const Header = () => {
  const { basePath = "", mode, updateContext, ...pathData } = usePath();
  const isMapPage = basePath?.includes("map");
  const { token } = useAuthState();
  const router = useRouter();
  const isDailyRentPage = mode === "daily";
  // const [clickTimer, setClickTimer] = useState(null);
  // const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    router.prefetch("/map/[...params]");
    router.prefetch("/map/daily-rent/[...params]");
    router.prefetch("/daily-rent/[...params]");
    router.prefetch("/[...params]");
    router.prefetch("/ad/[id]");
  }, []);

  const handleProfileButtonClick = (e) => {
    if (!token) {
      return router.push("/login");
    }

    e.target.dispatchEvent(
      new Event("opennewusersearchbar", {
        bubbles: true,
      })
    );
  };

  return (
    <div className={css.root}>
      <div>
        <button
          type="button"
          onClick={(e) => {
            trackGA4Event({
              event: events.SHOW_POPUP_SERVICE,
            });
            e.target.dispatchEvent(
              new Event("openservicepopup", { bubbles: true }),
            );
          }}
        >
          <Icon
            priority
            alt="قائمة الخدمات"
            name="ServiceList-blue"
            width={35}
            height={35}
          />
        </button>
        <AppLink
          className={css.logo}
          navigate
          onClick={() => {
            updateContext({
              basePath: "",
              isStatResults: undefined,
              listing: null,
              category: null,
              mode: null,
              project: null,
              homeLabel: "الرئيسية",
              skipRouting: true,
              page: 0,
              district: null,
              direction: null,
              polygon: undefined,
              city: null,
              daily_renting_filter: undefined,
              filters: {},
              developer: null,
              unit: null,
              activeCity: null,
            });
          }}
          path="/"
        >
          <Icon
            alt="شعار منصة عقار"
            name="v1/aqar-logo-v2"
            priority
            width={90}
            height={40}
            style={{
              width: "90px",
              height: "40px",
            }}
          />
        </AppLink>
      </div>
      <div>
        <AppLink
          onClick={() => {
            const pathData = {
              basePath: "/المشاريع-العقارية",
              homeLabel: "المشاريع العقارية",
              mode: "red",
              isStatResults: undefined,
              daily_renting_filter: undefined,
              category: undefined,
              page: 0,
              listing: null,
              project: null,
              city: null,
              direction: null,
              district: null,
              filters: {},
              polygon: undefined,
            };

            if (mode === "red") {
              pathData.basePath = "";
              pathData.mode = null;
              pathData.homeLabel = "الرئيسية";
            }
            updateContext(pathData);
          }}
          type="button"
          path="/المشاريع-العقارية"
          className={`${css.hideOnMobile} ${
            mode === "red" ? css.aqar : css.red
          }`}
        >
          <Icon
            alt="المشاريع العقارية"
            name={mode === "red" ? "aqarLogo-white" : "red"}
            width={15}
            priority
            height={15}
          />
          <span className={css.hideOnMobile}>
            {mode === "red" ? "العودة لعقار" : "المشاريع العقارية"}
          </span>
        </AppLink>
        <AppLink
          onClick={() => {
            const pathData = {
              basePath: "/الحجز-اليومي",
              mode: "daily",
              homeLabel: "الإيجار اليومي",
              daily_renting_filter: { availability: { eq: 1 } },
              category: DEFAULT_CATEGORY,
              page: 0,
              listing: null,
              project: null,
              city: null,
              direction: null,
              district: null,
              filters: {},
              isStatResults: undefined,

              polygon: undefined,
            };

            if (isDailyRentPage) {
              pathData.basePath = "";
              pathData.mode = null;
              pathData.homeLabel = "الرئيسية";
              pathData.daily_renting_filter = null;
            }
            if (basePath?.includes("map")) {
              pathData.basePath = `/map${pathData.basePath}`;
            }
            updateContext(pathData);
            if (!isDailyRentPage) {
              trackDailyRentStart();
            }
          }}
          path={isDailyRentPage ? "" : "/الحجز-اليومي"}
          type="button"
          className={`${isDailyRentPage ? css.aqar : css.daily} ${
            css.hideOnMobile
          }`}
        >
          <Icon
            alt={isDailyRentPage ? "شعار منصة عقار" : "الإيجار اليومي"}
            name={isDailyRentPage ? "aqarLogo-white" : "dailyRent-colored"}
            width={15}
            priority
            height={15}
          />
          {isDailyRentPage ? "العودة لعقار" : " الإيجار اليومي"}
        </AppLink>
        <AppLink
          onClick={() => {
            const path = { listing: null, polygon: undefined, page: undefined };

            /*Rest city,direction and district if listing*/
            if (pathData.listing) {
              path.district = null;
              path.city = null;
              path.direction = null;
            }
            if (isMapPage) {
              return updateContext({
                ...path,
                basePath: basePath.replace("/map", ""),
              });
            }

            trackGenericCTAClickEvent("listings_map_view", {
              listing_type: pathData.listingType,
              property_category: pathData.category?.en,
              source: decodeURI(document?.referrer),
            });

            return updateContext({
              ...path,
              basePath: `/map${basePath}`,
            });
          }}
          style={{
            padding: isMapPage ? ".5rem" : undefined,
          }}
          className={`${css.mode} ${isMapPage ? css.list : ""}`}
          type="button"
        >
          <Icon
            name={!isMapPage ? "MapSearch-colored" : "Listings-ListView"}
            alt={!isMapPage ? "بحث بالخريطة" : "بحث بالقائمة"}
            width={15}
            height={15}
            priority
          />
          <span className={css.hideOnMobile}>
            {isMapPage ? "بحث بالقائمة" : "بحث بالخريطة"}
          </span>
        </AppLink>
        <AppLink
          aria-label="إضافة اعلان"
          data-event-target="add an ad"
          onClick={(e) => {
            trackGenericCTAClickEvent(e);
            router.push("/add-listing");
          }}
          className={css.newAd}
        >
          <span className={css.addIcon} />
          <span className={css.hideOnMobile}>إضافة</span>
        </AppLink>

        <button
          onClick={handleProfileButtonClick}
          type="button"
          className={css.profile}
        >
          <Icon
            name="Profile"
            alt="حساب المستخدم"
            priority
            width={15}
            height={15}
          />
        </button>
      </div>
    </div>
  );
};

export default Header;
